import * as React from 'react';

import { ErrorLayout } from './ErrorLayout';
import image from '../assets/loading.png';

interface IReviewOnModerationErrorProps {
  onClose(): void;
}

export const ReviewOnModerationError: React.FC<IReviewOnModerationErrorProps> = ({ onClose }) => {
  return (
    <ErrorLayout
      image={image}
      title="Проверяем ваш&nbsp;отзыв"
      description="Опубликуем его&nbsp;сразу после&nbsp;проверки&nbsp;— иногда это&nbsp;занимает несколько дней"
      actions={[{ label: 'Понятно, спасибо', onClick: onClose }]}
    />
  );
};
